import Vue from 'vue';
import Vuex from 'vuex';
import Common from './modules/common.store';
import Items from './modules/items.store';
import Orders from './modules/orders.store';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		Common,
		Items,
		Orders
	}
})